export interface SaveEquipmentUsage {
  equipmentDispatchID: string | null;
  equipmentID: string | null;
  equipment: string | null;
  shift: number | null;
  workOrder: string | null;
  billingRate: number | null;
  billingTemplate: string | null;
  equipmentBillingID: string | null;
  details: SaveEquipmentUsageDetail[];
  foremanTimeImportID?: string | null;
  foremanEquipmentDispatchID?: string | null;
}

export interface SaveEquipmentUsageDetail {
  equipmentUsageID: string | null;
  dateUsed: Date | null;
  amount: number | null;
  bActive: boolean | null;
  foremanEquipmentUsageID: string | null;
  notes?: string | null;
}
